import SvgIcon from '@home/components/SvgIcon';
import React from 'react';
import { Button, ButtonProps } from 'tea-component';
import './index.scss';

interface IChatSwitchBtnProps extends ButtonProps {
  svgIcon?: string;
  isActive: boolean;
  showBeta?: boolean;
  /** Image src for default state icon */
  iconSrc?: string;
  /** Image src for active (highlighted) state icon */
  activeIconSrc?: string;
}

const ChatSwitchBtn = ({
  svgIcon, 
  isActive,
  children, 
  showBeta = false,
  iconSrc,
  activeIconSrc,
  ...props
}: IChatSwitchBtnProps) => {
  const currentIconSrc = isActive && activeIconSrc ? activeIconSrc : iconSrc;

  return (
    <Button 
      className={`dba-chat-button ${isActive && 'dba-chat-button-active'}`} 
      {...props}
    >
      {
        showBeta && <SvgIcon  className='dba-chat-button-beta-tag' type='beta' />
      }
      <span className='dba-chat-button-content'>
        {currentIconSrc 
          ? <img src={currentIconSrc} alt="" className="dba-chat-button-icon" /> 
          : svgIcon !== '' && <SvgIcon type={svgIcon} />
        }
        {children}
      </span>
    </Button>
  );
};

export default ChatSwitchBtn;